export const POINTS_IN_ONE_DOLLAR = 80;
export const POINTS_MAX_GIVE_TO_OTHER_DEVIANT_VALUE = 3500;
export const pointsToDollars = (points)=>(points / POINTS_IN_ONE_DOLLAR).toFixed(2);
export const dollarsToPoints = (dollars)=>Math.ceil(dollars * POINTS_IN_ONE_DOLLAR);
